
define('template!mailsMailRightCollapsedAttachmentView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="view-region"></div>\n<div class="att-caption">\n    <a class="att-name" href="' +
((__t = ( url )) == null ? '' : __t) +
'" download="' +
((__t = ( fileName )) == null ? '' : __t) +
'" title="' +
((__t = ( name )) == null ? '' : __t) +
'">' +
((__t = ( name )) == null ? '' : __t) +
'</a>\n    ';
 if (inline) { ;
__p += '<span class="att-inline" title="Inline attachment — embedded in the message body">inline</span>';
 } ;
__p += '\n</div>\n';

}
return __p
};});

